export default __webpack_public_path__ + "static/media/trash-white.4a4f85bd.svg";